import React from 'react';
import Translate from '../../../../utils/Translate';
import { EmailStore } from '../../../../state/EmailStore';
import { getLoyaltyLogoByTier } from '../common/commonLoyalty';
import { PersonalInfoStore } from '../../../../state/PersonalInfoStore';
import { LoyaltyPoints } from '../common/LoyaltyPoints';

import '../common/common-loyalty.css';
import './MergeLoyaltySummary.css';

export const MergeLoyaltySummary = () => {
  const summary = EmailStore.getLoyaltyMergeSummary();
  const tierCode = summary.tier.code;

  const headerImg = <img src={getLoyaltyLogoByTier(tierCode)} alt="loyalty-logo" className="summary-header-img"/>;

  return (
    <div>
      <div className={`summary-header -${tierCode}`}>
        <div className="summary-header-user-info loyalty-user-info">
          <div className="summary-header-img-container -eva-3-hide-small">
            {headerImg}
          </div>
          <div className="summary-header-text">
            <div className="summary-name-container">
              <div className="-eva-3-mr-sm -eva-3-hide-medium-up">
                {headerImg}
              </div>
              {PersonalInfoStore.name && <h4 className="summary-name -eva-3-ellipsis">{PersonalInfoStore.name}</h4>}
            </div>
            <div className="primary-email-container -eva-3-pt-xsm">
              <span className="-eva-3-pr-xsm -eva-3-ellipsis">{PersonalInfoStore.getPrimaryEmail()}</span>
              |
              <i className="eva-3-icon-star -eva-3-tc-brand-primary-3 -eva-3-pl-xsm"/>
              <span className="-eva-3-pl-xsm">
                {Translate.message('Principal')}
              </span>
            </div>
            <div className="secondary-email-container -eva-3-mt-sm">
              <span className="-eva-3-pr-xsm -eva-3-ellipsis">{EmailStore.getMergeableEmail()}</span>
              |
              <span className="-eva-3-pl-xsm">{Translate.message('Secundario')}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={`summary-info -${tierCode}`}>
        <div className="tier-category-container">
          <div>
            <h3 className="tier-category eva-3-h3">{Translate.message('Pasaporte')} {summary.tier.name}</h3>
          </div>
          {summary.tier.expirationDate &&
            <div className="tier-expiration -eva-3-mt-lg -eva-3-hide-small">
              <span>{Translate.message('merge-loyalty-summary.tier.expirationDate')} {summary.tier.expirationDate}</span>
            </div>
          }
        </div>
        <div className="summary-points-container">
          <LoyaltyPoints
            availablePoints={summary.availablePoints}
            pendingPoints={summary.pendingPoints}
            isSummary
          />
        </div>
      </div>
      <div className="separator -eva-3-hide-small"/>
      <div className="summary-disclaimer -eva-3-mb-xlg">
        <span>{Translate.message('merge-loyalty-summary.caption')}</span>
      </div>

    </div>
  );
};
